<template>
  <div class="battle">
    <div v-if="stage === 0" class="pre" v-on:click="nextStage()">
      <img class="politician-img" src="../assets/img/politician.jpg">
      <div class="politician-comment">{{dummy[0].speech}}</div>
    </div>
    <div v-if="stage >= 1 && stage <= 8 " class="pursuit">
      <div v-if="stage === 1" class="top" v-on:click="nextStage()">
        <div class="politician-comment">{{dummy[0].speech}}</div>
      </div>
      <div v-if="stage >= 2 && stage <= 3 || stage === 6" class="top">
        <div class="choices">
          <div class="choice choice1" v-on:click="answer(0)">
            <div class="head-num">1</div>
            <div class="choice-desk">{{choices[0]}}</div>
          </div>
          <div class="choice choice2" v-on:click="answer(1)">
            <div class="head-num">2</div>
            <div class="choice-desk">{{choices[1]}}</div>
          </div>
          <div class="choice choice3" v-on:click="answer(2)">
            <div class="head-num">3</div>
            <div class="choice-desk">{{choices[2]}}</div>
          </div>
        </div>
      </div>
      <div v-if="stage >= 4 && stage <= 5 || (stage >= 7 && stage <= 8)" class="top" v-on:click="nextStage()">
        <div class="evidence-img-wrap">
          <img class="evidence-img" :src="evidenceImg">
        </div>
      </div>
      <div class="bottom">
        <div class="talks" v-if="stage !== 8" v-on:click="nextStage()">
          <div class="taik1">
            <div class="thumbnail">
              <img class="avatar" src="../assets/img/avatars/boy-talking.gif">
            </div>
            <div class="comment">
              <div v-if="boyMem" class="balloon balloon-left">{{boyMem}}</div>
            </div>
          </div>
          <div class="taik2">
            <div class="comment">
              <div v-if="girlMem" class="balloon balloon-right">{{girlMem}}</div>
            </div>
            <div class="thumbnail">
              <img class="avatar" src="../assets/img/avatars/girl-talking-2.gif">
            </div>
          </div>
        </div>
        <div v-else class="judge">
          <div>
            <h1>判定は？</h1>
            <div class="choices">
              <div class="choice shake">
                <img src="../assets/img/circle.png">
                <p>正しい</p>
              </div>
              <div class="choice" v-on:click="answer(1)">
                <img src="../assets/img/triangle.png">
                <p>一部間違い</p>
              </div>
              <div class="choice shake">
                <img src="../assets/img/cross.png">
                <p>間違い</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="stage === 9" class="loading">
      <img class="load-icon" src="../assets/img/puff.svg">
      <img class="avatar" src="../assets/img/avatars/boy-talking.gif">
    </div>
    <div v-if="stage === 10" class="result">
      <div>
        <div class="result-icon">
          <img src="../assets/img/triangle.png">
          <h1>一部間違い</h1>
        </div>
        <div class="description">
          新党の相次ぐ誕生と経済の低迷に直接の因果関係があるとは言えず、主張は正しいとは言えない
        </div>
        <router-link to="/" class="back-link"><h3 >戻る</h3></router-link>
      </div>
    </div>
  </div>
</template>

<script>
import dummy from '../assets/dummy-data.js';
console.log(dummy);

export default {
  name: 'battle',
  data: () => {
    return {
      stage: 0,
      subStage: 0,
      boyMem: "",
      girlMem: "",
      choices: ["", "", ""],
      evidenceImg: "",
      dummy: dummy,
    }
  },
  // mounted: () => {}
  methods: {
    initMems() {
      this.boyMem = "",
      this.girlMem = ""
    },
    nextStage() {
      if (this.stage === 2 || this.stage === 3) return;

      switch(this.stage) {
        case 1:
          switch(this.subStage) {
            case 0:
              this.boyMem = "選挙だね。与党の議員も一生懸命だ。"
              this.subStage += 1;
              break;
            case 1:
              this.girlMem = "でも、少しおかしくない？　ファクト君、ファクトチェックしてみてよ。";
              this.subStage += 1;
              break;
            case 2:
              this.initMems();
              this.stage += 1;
              this.choices = ["今回は重要な選挙です。新しい党が次々できました。", "何党なのか名前もわからないですね。私は名前が変わっただけで、結局、中身は何も変わっていないと思います。", "１９９０年代、新党ブームがありました。この新党ブームが生み出したものは何だったのでしょうか。それは残念ながら政治の混乱と経済の低迷でした。"];
              this.boyMem = "どこを調べる？";
            default:
              break;
          }
          break;
        case 4:
          switch(this.subStage) {
            case 0:
              this.boyMem = "この発言は正しいね"
              this.subStage += 1;
              break;
            case 1:
              this.girlMem = "でも、他におかしい部分があるんじゃない？";
              this.subStage += 1;
              break;
            case 2:
              this.stage = 3;
              this.subStage = 0;
              this.initMems();
            default:
              break;
          }
          break;
        case 5:
          switch(this.subStage) {
            case 0:
              this.boyMem = "政治は混乱していたね。じゃあ、この発言は正しいんだ"
              this.subStage += 1;
              break;
            case 1:
              this.girlMem = "もう少し、よく見てみよう。";
              this.subStage += 1;
              break;
            case 2:
              this.stage = 6;
              this.subStage = 0;
              this.choices = ["朝日新聞", "日経平均株価", "国会議事録"];
              this.initMems();
            default:
              break;
          }
          break;
          case 7:
            switch(this.subStage) {
              case 0:
                this.boyMem = "あれ？　株価が下がっているのは細川政権が誕生する前だ。"
                this.subStage += 1;
                break;
              case 1:
                this.girlMem = "そうなの。新党ブームの前から経済は低迷した、ということだね。";
                this.subStage += 1;
                break;
              case 2:
                this.stage += 1;
                this.subStage = 0;
              default:
                break;
            }
          break;
        default:
          this.stage += 1;
          this.subStage = 0;
          break;
      }
    },
    answer(index) {
      if(this.stage === 2) {
        this.boyMem = "";

        switch(index) {
          case 0:
            this.girlMem = "それは事実みたいだね。ファクトチェックの対象じゃないよ。";
            break;
          case 1:
            this.girlMem = "それは政治家の意見だから、ファクトチェックの対象じゃないよ。";
            break;
          case 2:
            this.girlMem = "";
            this.boyMem = "どうやって調べる？"
            this.stage += 1;
            this.choices = ["朝日新聞", "国会議事録", "現代政治史の教科書"];
            break;
        }
      }
      else if(this.stage === 3) {
        this.boyMem = "";

        switch(index) {
          case 0:
            this.initMems();
            this.evidenceImg = "/static/img/newspaper.jpg",
            this.stage = 5;
            this.subStage = 0;
            break;
          case 1:
            this.girlMem = "探してみたけど、議事録には関連するファクトは見当たらなかったよ。";
            break;
          case 2:
            this.initMems();
            this.evidenceImg = "/static/img/graph2.jpg",
            this.stage += 1;
            this.subStage = 0;
            break;
        }
      }
      else if(this.stage === 6) {
        this.boyMem = "";

        switch(index) {
          case 0:
            this.girlMem = "それはさっき調べたよ";
            break;
          case 1:
            this.initMems();
            this.evidenceImg = "/static/img/graph.png",
            this.stage += 1;
            this.subStage = 0;
            break;
          case 2:
            this.girlMem = "探してみたけど、議事録には関連するファクトは見当たらなかったよ。";
            break;
        }
      }
      else if(this.stage === 8) {
        this.stage = 9;
        setTimeout(() => {
          this.stage = 10;
        }, 2500);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.battle {
  // opacity: 0;
  // animation: splash 0.5s ease 0.1s 1 forwards;
  height: 100vh;
}

.politician-comment {
  padding: 8px;
  color: #fff;
}

.pre {
  height: 100%;
  opacity: 0;
  animation: splash 0.5s ease 0.1s 1 forwards;

  background: rgba(237, 21, 34, 0.7);
  .politician-img {
    width: 100%;
  }
  .politician-comment {
    height: calc(100% - 528px);
    overflow-y: auto;
  }
}

.pursuit {
  opacity: 0;
  animation: splash 0.5s ease 0.1s 1 forwards;
  .top {
    position: relative;
    height: 50vh;
    overflow: hidden;
    background-image: url("../assets/img/politician.jpg");
    background-size: cover;
    opacity: 0;
    animation: splash 0.5s ease 0.1s 1 forwards;

    .politician-img {
      width: 100%;
    }
    .politician-comment {
      position: absolute;
      bottom: 0;
      left: 0;
      background: rgba(237, 21, 34, 0.7);
    }

    .choices {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      background: rgba(237, 21, 34, 0.7);
      color: #fff;
    }
    .choice {
      display: flex;
      flex: 1;
      padding: 8px;
      border: 1px solid #fff;

      .head-num {
        font-size: 64px;
      }
      .choice-desc {
        text-align: left;
      }
    }
    .choice:hover {
      background: rgba(237, 21, 34, 1);
    }

    .evidence-img-wrap {
      display: flex;
      justify-content: center;
      width: 100%;;
      height: 100%;;
      width: auto;
    };
    .evidence-img {
      height: 100%;
    }
  }
  .bottom {
    height: 50vh;

    .taik1 {
      height: 50%;
      display: flex;
      align-items: center;
      .thumbnail {
        width: 40%;
        align-items: center;
        img {
          width: 100%;
        }
      }
      .comment {
        width: 60%;
        padding: 16px;
      }
    }
    .taik2 {
      height: 50%;
      display: flex;
      align-items: center;
      .thumbnail {
        width: 40%;
        align-items: center;
        img {
          width: 100%;
        }
      }
      .comment {
        width: 60%;
        padding: 16px;
      }
    }

    .judge {
      display: flex;
      align-items: center;
      height: 50vh;
      padding: 16px;
      color: #fff;
      background: rgba(237, 21, 34, 1);

      h1, h3 {
        text-align: center;
      }

      .choices {
        display: flex;
        flex-direction: row;

        .choice {
          display: flex;
          flex: 1;
          justify-content: flex-end;
          align-items: center;
          flex-direction: column;

          img { width: 60% }
        }
        .choice:hover {
          background: rgba(237, 21, 34, 0.7);
        }
        .shake:hover {
          animation-name: shake;
          animation-duration: 0.1s;
          animation-iteration-count: 2.5;
        }
      }
    }
  }
}

.loading {
  opacity: 0;
  animation: splash 0.5s ease 0.1s 1 forwards;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 96vh;
  padding: 16px;
  background: rgba(237, 21, 34, 1);

  .load-icon {
    height: 10vh;
  }

  .avatar {
    position: absolute;
    bottom: 16px;
    height: 50%;
  }
}

.result {
  opacity: 0;
  animation: splash 0.5s ease 0.1s 1 forwards;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 96%;
  padding: 16px;
  background: rgba(237, 21, 34, 1);
  color: #fff;

  .result-icon {
    text-align: center;
    img { width: 40%;}
  }

  .description {
    margin: 24px 0;
  }

  .back-link {
    text-align: center;
    color: aliceblue;
    text-decoration: none;
  }
}

@keyframes splash {
  100% {
    opacity: 1;
  }
}

@keyframes shake {
    0% {transform: translate(0px, 0px) rotateZ(0deg)}
    25% {transform: translate(4px, 4px) rotateZ(1deg)}
    50% {transform: translate(0px, 4px) rotateZ(0deg)}
    75% {transform: translate(4px, 0px) rotateZ(-1deg)}
    100% {transform: translate(0px, 0px) rotateZ(0deg)}
}

.balloon {
  opacity: 0;
  animation: splash 0.5s ease 0.1s 1 forwards;
}

.balloon-left {
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px;
  // margin: 1.5em 0 1.5em 15px;
  // padding: 7px 10px;
  width: 100%;
  height: 85%;
  color: #ed1522;
  // font-size: 16px;
  border: solid 3px #ed1522;
  box-sizing: border-box;
  border-radius: 4px;
  line-height: 1.3;
}
.balloon-left:before{
  content: "";
  position: absolute;
  top: 50%;
  left: -24px;
  margin-top: -12px;
  border: 12px solid transparent;
  border-right: 12px solid #FFF;
  z-index: 2;
}

.balloon-left:after{
  content: "";
  position: absolute;
  top: 50%;
  left: -30px;
  margin-top: -14px;
  border: 14px solid transparent;
  border-right: 14px solid #ed1522;;
  z-index: 1;
}

.balloon-right {
 	position: relative;
  display: flex;
  align-items: center;
  padding: 8px;
  width: 100%;
  height: 85%;
  color: #ed1522;
	font-size: 16px;
  border: solid 3px #ed1522;
 	box-sizing: border-box;
  border-radius: 4px;
  line-height: 1.3;
}

.balloon-right:before{
	content: "";
	position: absolute;
	top: 50%;
	right: -24px;
 	margin-top: -12px;
	border: 12px solid transparent;
	border-left: 12px solid #FFF;
 	z-index: 2;
}

.balloon-right:after{
	content: "";
	position: absolute;
	top: 50%;
	right: -30px;
 	margin-top: -14px;
	border: 14px solid transparent;
	border-left: 14px solid #ed1522;
 	z-index: 1;
}

</style>


// WEBPACK FOOTER //
// src/components/battle.vue